// loaders
export const LOADER_CHANGE_LOCALE = 'change-locale';
export const LOADER_CHANGE_TRACKING = 'change-tracking';

export const LOADER_DELETE_ACCOUNT = 'delete-account';

export const LOADER_FETCH_LATEST_TRANSACTIONS = 'fetch-latest-transactions';
export const LOADER_FETCH_TRANSACTIONS = 'fetch-transactions';
export const LOADER_FETCH_PENDING_CONTRACTS = 'fetch-pending-contracts';
export const LOADER_FETCH_PRODUCTS = 'fetch-products';
export const LOADER_FETCH_APPROVALS = 'fetch-participant-approvals';
export const LOADER_FETCH_CONTRACT_APPROVALS = 'fetch-contract-approvals';
export const LOADER_FETCH_NEWS = 'fetch-news';
export const LOADER_FETCH_NEWS_DETAIL = 'fetch-news-detail';
export const LOADER_FETCH_NEWS_LATEST = 'fetch-news-latest';
export const LOADER_FETCH_WISHLIST = 'fetch-wishlist';
export const LOADER_CART = 'cart';
export const LOADER_CHECKOUT = 'checkout-cart';
export const LOADER_ADD_CART = 'add-cart';
export const LOADER_UPDATE_CART = 'update-cart';
export const LOADER_REMOVE_CART = 'remove-cart';
export const LOADER_NEW_RETAILER_VALIDATION = 'new-retailer-validation';
export const LOADER_NEW_RETAILER_SUBMISSION = 'new-retailer-submission';

export const LOADER_APPROVE_PARTICIPANT = 'approve-participant-';
export const LOADER_APPROVE_CONTRACT = 'approve-contract-';
export const LOADER_DECLINE_PARTICIPANT = 'decline-participant-';
export const LOADER_DECLINE_CONTRACT = 'decline-contract-';

export const LOADER_SUBMIT_REGISTER = 'submit-register';
export const LOADER_SUBMIT_CONTRACT = 'submit-contract';
export const LOADER_SUBMIT_LOGIN = 'submit-login';
export const LOADER_RESEND_TWO_FACTOR = 'submit-rest-two-factor';
export const LOADER_TWO_FACTOR = 'submit-two-factor';
export const LOADER_SUBMIT_LOGOUT = 'submit-logout';
export const LOADER_REFRESH_TOKEN = 'token-refresh';
export const LOADER_SUBMIT_AVATAR = 'submit-avatar';
export const LOADER_SUBMIT_CONTACT = 'submit-contact';
export const LOADER_SUBMIT_WISHLIST = 'submit-wishlist';
export const LOADER_SUBMIT_CHANGE_DATA = 'submit-change-data';
export const LOADER_RESEND_VERIFICATION = 'resend-verification';
export const LOADER_SUBMIT_CHANGE_COMPANY_DATA = 'submit-change-company-data';
export const LOADER_SUBMIT_FEEDBACK = 'submit-feedback';

export const LOADER_RESET_PASSWORD = 'submit-reset-password';

// routes
export const ROUTE_DASHBOARD = 'dashboard';
export const ROUTE_CHANGE_AVATAR = 'change-avatar';
export const ROUTE_CHANGE_DATA = 'change-data';
export const ROUTE_CHANGE_COMPANY_DATA = 'change-company-data';
export const ROUTE_CHANGE_RETAILER_SUCCESS = 'change-retailer-success';
export const ROUTE_CHANGE_RETAILER = 'change-retailer';
export const ROUTE_SUBMIT_CONTRACT = 'add-contract';
export const ROUTE_MY_ORDERS = 'my-orders';
export const ROUTE_ORDER_DETAILS = 'order-item-details';
export const ROUTE_WISHLIST = 'wishlist';
export const ROUTE_SHOP = 'shop';
export const ROUTE_ACCOUNT = 'account';
export const ROUTE_IMPERSONATE = 'impersonate';
export const ROUTE_OPEN_APP = 'app';
export const ROUTE_ADD_CONTRACT = 'add-contract';
export const ROUTE_PROFILE = 'profile';
export const ROUTE_APPROVALS = 'approvals';
export const ROUTE_PRODUCT_DETAILS = 'product';
export const ROUTE_LOGIN = 'login';
export const ROUTE_LOGIN_DEEPLINK = 'login-deeplink';
export const ROUTE_REGISTER_CONFIRMATION = 'register-confirmation';
export const ROUTE_CONFIRMATION = 'confirmation';
export const ROUTE_CONTACT = 'contact';
export const ROUTE_NEWS = 'news';
export const ROUTE_STATIC_PAGE = 'static-page';
export const ROUTE_RANG = 'rang';
export const ROUTE_RANK = 'rank';
export const ROUTE_CART = 'cart';
export const ROUTE_CHECKOUT = 'checkout';
export const ROUTE_STATISTIC_DETAIL = 'statistic';

// local storage
export const LOCAL_STORAGE_ENDPOINT = 'apiendpoint';
export const LOCAL_STORAGE_USER = 'user';
export const LOCAL_STORAGE_JWT = 'jwt';
export const LOCAL_STORAGE_DATA_INVALIDATION = 'data_invalidation';
export const LOCAL_STORAGE_TOKEN_EXPIRES = 'token_expires';
export const LOCAL_STORAGE_LOCALE = 'locale';

// api endpoints
export const API_ENDPOINT_POST_APPROVAL_APPROVE = 'approvals/approve';
export const API_ENDPOINT_POST_APPROVAL_DECLINE = 'approvals/decline';
export const API_ENDPOINT_POST_CONTRACT_APPROVE = 'contracts/approve';
export const API_ENDPOINT_POST_CONTRACT_DECLINE = 'contracts/decline';
export const API_ENDPOINT_POST_CONTRACT = 'contracts/create';
export const API_ENDPOINT_POST_AVATAR = 'profile/set-avatar';
export const API_ENDPOINT_POST_ADD_TO_WISHLIST = 'wishlists/add';
export const API_ENDPOINT_POST_REMOVE_FROM_WISHLIST = 'wishlists/remove';
export const API_ENDPOINT_POST_CONTACT = 'submit-contact';
export const API_ENDPOINT_POST_CHANGE_DATA = 'profile/update';
export const API_ENDPOINT_POST_CHANGE_COMPANY_DATA = 'taxation-documentation/update';
export const API_ENDPOINT_RESEND_VERIFICATION_MAIL = 'resend-taxation-email';

export const API_ENDPOINT_FETCH_APPROVALS = 'approvals';
export const API_ENDPOINT_FETCH_CONTRACTS = 'contracts';
export const API_ENDPOINT_FETCH_CONTRACT_APPROVALS = 'contracts/approvals';
export const API_ENDPOINT_FETCH_TRANSACTIONS = 'transactions';
export const API_ENDPOINT_FETCH_TRANSACTIONS_LATEST = 'transactions/latest';
export const API_ENDPOINT_FETCH_PRODUCTS = 'products';
export const API_ENDPOINT_FETCH_NEWS = 'news';
export const API_ENDPOINT_FETCH_NEWS_DETAIL = 'news/';
export const API_ENDPOINT_FETCH_NEWS_LATEST = 'news/latest';
export const API_ENDPOINT_FETCH_WISHLIST = 'wishlists';

export const API_ENDPOINT_LOGIN = 'login';
export const API_ENDPOINT_RESEND_TWO_FACTOR = 'resend-two-factor-code';
export const API_ENDPOINT_LOGOUT = 'logout';
export const API_ENDPOINT_SUBMIT_DEVICE = 'device-tokens/create';
export const API_ENDPOINT_REFRESH_TOKEN = 'refresh-token';
export const API_ENDPOINT_REST_PASSWORD = 'password/reset';
export const API_ENDPOINT_UPDATE_INTRO = 'profile/update-intro';

export const API_ENDPOINT_REGISTER_PARTICIPANT = 'register/participant';
export const API_ENDPOINT_REGISTER_COMPANY_START = 'register/company/start';
export const API_ENDPOINT_REGISTER_COMPANY_PROCEED = 'register/company/proceed/';
export const API_ENDPOINT_REGISTER_COMPANY_FINALIZE = 'register/company/finalize';

export const API_ENDPOINT_CHANGE_LOCALE = 'profile/set-locale';
export const API_ENDPOINT_CHANGE_TRACKING = 'profile/toggle-tracking';
export const API_ENDPOINT_DELETE_ACCOUNT = 'profile/delete';
export const API_ENDPOINT_NEW_RETAILER_VALIDATION = 'profile/reassign/validate';
export const API_ENDPOINT_NEW_RETAILER_SUBMISSION = 'profile/reassign/submission';

export const API_ENDPOINT_POST_FEEDBACK = 'orders/report';

// cart
export const API_ENDPOINT_FETCH_CART = 'shopping-carts';
export const API_ENDPOINT_ADD_TO_CART = 'shopping-carts/add';
export const API_ENDPOINT_REMOVE_FROM_CART = 'shopping-carts/remove';
export const API_ENDPOINT_UPDATE_ON_CART = 'shopping-carts/update';
export const API_ENDPOINT_CHECKOUT_CART = 'shopping-carts/checkout';

export const POINTS_FILTER = [
    {
        min: 0,
        max: 1500,
    },
    {
        min: 1501,
        max: 3500,
    },
    {
        min: 3501,
        max: 10000,
    },
];

export const RANK = {
    member: 'Member',
    superior_master: 'Superior Master',
    legend_master: 'Legend Master',
    ultimate_master: 'Ultimate Master',
}
